var _g, _text, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadingDrag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_104472",
    "data-name": "Group 104472",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 102,
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226",
    "data-name": "Rectangle 146226",
    fill: "#83ffb9",
    stroke: "#29e67c",
    strokeWidth: 1,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 102,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Two",
    transform: "translate(49 86)",
    fill: "#29e67c",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.667,
    y: 0
  }, "Heading"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "font_download_black_24dp",
    transform: "translate(26.442 16.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    "data-name": "Path 61963",
    d: "M0,0H45.035V45.035H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x33_4.Heading",
    d: "M42.517,28.076V55.125h2.7a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352H31.7a1.352,1.352,0,0,1-1.352-1.352v-2.7A1.352,1.352,0,0,1,31.7,55.125h2.7V44.306H18.172v10.82h2.7a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352H7.353A1.352,1.352,0,0,1,6,59.183v-2.7a1.352,1.352,0,0,1,1.352-1.352h2.7V28.076h-2.7A1.352,1.352,0,0,1,6,26.723v-2.7a1.352,1.352,0,0,1,1.352-1.352H20.877a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352h-2.7V38.9H34.4V28.076H31.7a1.352,1.352,0,0,1-1.352-1.352v-2.7A1.352,1.352,0,0,1,31.7,22.666H45.222a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352Z",
    transform: "translate(-3.771 -19.083)",
    fill: "#29e67c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingDrag);
export default __webpack_public_path__ + "static/media/Heading_drag.a039c73aa729f71b98819b7d29ac738d.svg";
export { ForwardRef as ReactComponent };